<script setup>
  import { storeToRefs } from "pinia";
  import NavButton from "@/components/App/NavButton.vue";
  import { useContactsStore } from "@stores/survey/mailing/contacts";

  const contactsStore = useContactsStore();
  const { haveContactsChanged } = storeToRefs(contactsStore);
  const { saveContacts } = contactsStore;
</script>

<template>
  <NavButton
    :can-trigger="haveContactsChanged"
    :action-function="saveContacts" />
</template>
